module.exports = __webpack_public_path__ + "static/img/master.d296d66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/payment-partner/master.png
// module id = bFKc
// module chunks = 1